const EVENTS = {
  ACCOUNT_MODAL: {
    OPEN: 'header|account-modal|open',
    CLOSE: 'header|account-modal|close',
    GO_TO_TAB: {
      CREATE_ACCOUNT: 'header|account-modal|go-to-tab|create-account',
      SIGN_IN: 'header|account-modal|go-to-tab|sign-in',
      FORGOT_PASSWORD: 'header|account-modal|go-to-tab|forgot-password',
      RESET_PASSWORD: 'header|account-modal|go-to-tab|reset-password',
    },
  },
  SUPPORT_DROP_DOWN: {
    CLOSE: 'header|support-dropdown|close'
  },
  AUTH: {
    FETCH_PROFILE: 'header|auth|fetch-profile'
  }
};

export default EVENTS;
